// extracted by mini-css-extract-plugin
export default {"form_error":"signUpClientView_form_error__sjfwq"};